import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getSlice } from '../../data/data2d/Spectrum2D';
import { useMouseTracker } from '../EventsTrackers/MouseTracker';
import { useChartData } from '../context/ChartContext';
import { useActiveSpectrum } from '../hooks/useActiveSpectrum';
import HorizontalSliceChart from './1d-tracer/HorizontalSliceChart';
import VerticalSliceChart from './1d-tracer/VerticalSliceChart';
import { get2DXScale, get2DYScale } from './utilities/scale';
function SlicingView() {
    const { width, height, margin, data: spectra, xDomain, yDomain, } = useChartData();
    const position = useMouseTracker();
    const activeSpectrum = useActiveSpectrum();
    const chart2d = useMemo(() => {
        if (position && activeSpectrum && activeSpectrum.id) {
            const { x, y } = position;
            const scale2dX = get2DXScale({ margin, width, xDomain });
            const scale2dY = get2DYScale({ margin, height, yDomain });
            const data = getSlice(spectra[activeSpectrum.index], {
                x: scale2dX.invert(x),
                y: scale2dY.invert(y),
            });
            return (_jsxs("svg", { viewBox: `0 0 ${width} ${height}`, width: width, height: height, style: {
                    position: 'absolute',
                    backgroundColor: 'rgba(255,255,255,0.8)',
                }, children: [data?.horizontal && (_jsx(HorizontalSliceChart, { data: data.horizontal.data })), data?.vertical && (_jsx(VerticalSliceChart, { data: data.vertical.data, reverseScale: true }))] }));
        }
        return null;
    }, [
        position,
        activeSpectrum,
        margin,
        width,
        xDomain,
        height,
        yDomain,
        spectra,
    ]);
    if (!position) {
        return null;
    }
    return chart2d;
}
export default SlicingView;
